export default __webpack_public_path__ + "locales/nl/SmartBanner.json?hash=8015a482f6ba110e0a4a37896d1ad834";